/**
 * ConvertCreditWarning — the loud, unmissable banner a convert-to-sales-order
 * screen shows when the dealer is over his credit limit or past his credit days.
 *
 * LOCKED SPEC 2026-09-23 screen 4 · plan Task 6.
 *
 * 🔒 L6 — WARN, NEVER BLOCK. By the time this renders the SERVER HAS ALREADY
 * CREATED THE ORDER (`creditWarning` rides on the convert response). So this
 * banner has no Cancel, no override, nothing to approve: it states the money
 * and hands the user the order it just made. Anything that made the order
 * harder to reach from here would be a block in disguise.
 */
import { AlertTriangle } from 'lucide-react';
import { creditChipReasons, rupees } from './dealerLedgerApi';
import type { CreditWarning } from './dealerLedgerApi';

export function ConvertCreditWarning({
  warning,
  onOpenOrder,
  onDismiss,
}: {
  warning: CreditWarning;
  onOpenOrder?: () => void;
  onDismiss?: () => void;
}) {
  const reasons = creditChipReasons(warning);
  return (
    <div
      data-testid="convert-credit-warning"
      role="alert"
      className="mb-3 flex flex-wrap items-center gap-3 rounded-xl border border-red-300 bg-red-50 p-3 text-sm text-red-800"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        <strong className="font-semibold">Order created.</strong> This dealer owes{' '}
        {rupees(warning.balancePaise)}
        {reasons.length > 0 ? ` — ${reasons.join(' · ')}` : ''}.
      </span>
      {onOpenOrder ? (
        <button
          type="button"
          onClick={onOpenOrder}
          className="ml-auto rounded-lg bg-red-700 px-3 py-1.5 text-xs font-semibold text-white hover:bg-red-800"
        >
          Open the sales order
        </button>
      ) : null}
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="rounded-lg border border-red-300 px-3 py-1.5 text-xs font-medium text-red-700 hover:bg-red-100"
        >
          Dismiss
        </button>
      ) : null}
    </div>
  );
}
